export default Object.freeze([
  {
    'id': 0,
    'nome': 'GERAL',
  },
  {
    'id': 1,
    'nome': 'PIRITUBA-JARAGUA',
    'spTrans': 'Noroeste',
  },
  {
    'id': 2,
    'nome': 'FREGUESIA-BRASILANDIA',
    'spTrans': 'Noroeste',
  },
  {
    'id': 3,
    'nome': 'CASA VERDE-CACHOEIRINHA',
    'spTrans': 'Norte',
  },
  {
    'id': 4,
    'nome': 'SANTANA-TUCURUVI',
    'spTrans': 'Norte',
  },
  {
    'id': 5,
    'nome': 'JACANA-TREMEMBE',
    'spTrans': 'Norte',
  },
  {
    'id': 6,
    'nome': 'VILA MARIA-VILA GUILHERME',
    'spTrans': 'Norte',
  },
  {
    'id': 7,
    'nome': 'PENHA',
    'spTrans': 'Nordeste',
  },
  {
    'id': 8,
    'nome': 'ERMELINO MATARAZZO',
    'spTrans': 'Nordeste',
  },
  {
    'id': 9,
    'nome': 'SAO MIGUEL',
    'spTrans': 'Nordeste',
  },
  {
    'id': 10,
    'nome': 'ITAIM PAULISTA',
    'spTrans': 'Nordeste',
  },
  {
    'id': 11,
    'nome': 'ITAQUERA',
    'spTrans': 'Leste',
  },
  {
    'id': 12,
    'nome': 'GUAIANASES',
    'spTrans': 'Leste',
  },
  {
    'id': 13,
    'nome': 'LAPA',
    'spTrans': 'Centro',
  },
  {
    'id': 14,
    'nome': 'SE',
    'spTrans': 'Centro',
  },
  {
    'id': 15,
    'nome': 'MOOCA',
    'spTrans': 'Centro',
  },
  {
    'id': 16,
    'nome': 'ARICANDUVA-FORMOSA-CARRAO',
    'spTrans': 'Leste',
  },
  {
    'id': 17,
    'nome': 'SAO MATEUS',
    'spTrans': 'Leste',
  },
  {
    'id': 18,
    'nome': 'VILA PRUDENTE',
    'spTrans': 'Sudeste',
  },
  {
    'id': 19,
    'nome': 'IPIRANGA',
    'spTrans': 'Sudeste',
  },
  {
    'id': 20,
    'nome': 'VILA MARIANA',
    'spTrans': 'Centro',
  },
  {
    'id': 21,
    'nome': 'BUTANTA',
    'spTrans': 'Oeste',
  },
  {
    'id': 22,
    'nome': 'PINHEIROS',
    'spTrans': 'Centro',
  },
  {
    'id': 23,
    'nome': 'CAMPO LIMPO',
    'spTrans': 'Sudoeste',
  },
  {
    'id': 24,
    'nome': "M'BOI MIRIM",
    'spTrans': 'Sudoeste',
  },
  {
    'id': 25,
    'nome': 'CAPELA DO SOCORRO',
    'spTrans': 'Sul',
  },
  {
    'id': 26,
    'nome': 'CIDADE ADEMAR',
    'spTrans': 'Sul',
  },
  {
    'id': 27,
    'nome': 'PARELHEIROS',
    'spTrans': 'Sul',
  },
  {
    'id': 28,
    'nome': 'JABAQUARA',
    'spTrans': 'Sul',
  },
  {
    'id': 29,
    'nome': 'SANTO AMARO',
    'spTrans': 'Sul',
  },
  {
    'id': 30,
    'nome': 'CIDADE TIRADENTES',
    'spTrans': 'Leste',
  },
  {
    'id': 31,
    'nome': 'PERUS',
    'spTrans': 'Noroeste',
  },
  {
    'id': 32,
    'nome': 'SAPOPEMBA',
    'spTrans': 'Sudeste',
  },
])
